import React, { useState, useEffect } from 'react';
import Layout from '../Layout';
import { getProduct, getUserInfo, getMyListedItems } from '../../user/apiUser';
import { useParams, Link, useHistory } from 'react-router-dom';
import { API, GOOGLE_API, APP_URL } from '../../config';
import { Disclosure, RadioGroup, Tab } from '@headlessui/react'
import { StarIcon } from '@heroicons/react/solid'
import { HeartIcon, MinusSmIcon, PlusSmIcon, ShieldCheckIcon } from '@heroicons/react/outline'
import { QuestionMarkCircleIcon } from '@heroicons/react/solid'
import ChooseItemModal from './ChooseItemModal';
import { isAuthenticated } from '../../auth';
import { getActiveTrades } from '../../user/apiUser';
import SignupModal from '../../user/SignupModal';
import SigninModal from '../../user/SigninModal';
import { generateSignin, estimateShipping } from './apiProduct';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import Badges from './Badges';
//import BuyButton from './BuyButton'; //TODO: rename to PayPaButtons or something
import Geocode from 'react-geocode';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const ProductPage = () => {
    const { productId } = useParams();
    const history = useHistory();
    const [item, setItem] = useState({secondary_photos:['Loading']}); //change name to product when done
    const [userInfo, setUserInfo] = useState({name: ''});
    const [userRating, setUserRating] = useState({rating: 0, length: 0});
    const [shippingCost, setShippingCost] = useState('Loading Rate');
    const [allPhotos, setAllPhotos] = useState([]);

    const [activeTrades, setActiveTrades] = useState([]);
    const [isTrading, setIsTrading] = useState(false);

    //Signin/Signup modal states
    const [signupOpen, setSignupOpen] = useState(false);
    const handleSignupClose = () => setSignupOpen(false);
    const handleOpenSignup = () => setSignupOpen(true);

    const [buyNowUrl, setBuyNowUrl] = useState(''); //can either be paypal onboard or checkout link

    const [userItems, setUserItems] = useState([]);
    const [openItemModal, setOpenItemModal] = useState(false);
    const handleTradeOpen = () => { //getMyListedItems call here
        //{ user, _id } = isAuthenticated();
        if (isAuthenticated()) {
            const { user: {_id}, token } = isAuthenticated();
            setOpenItemModal(true);
            getMyListedItems(_id, token).then(data => {
                setUserItems(data);
            });
        }
        else {
            /* Show login modal here */
            setSignupOpen(true);
        }

    };
    const handleClose = () => setOpenItemModal(false);
    
    const [buyOpen, setBuyOpen] = useState(false);
    const handleBuyClose = () => setBuyOpen(false);

    const handleBuyOpen = () => {
        if (isAuthenticated()) {
            //to signed in checkout page
            history.push(`/checkout/${item._id}`);
        }
        else {
            //signin thing
            //guest checkout page
            setBuyOpen(true);
        }
    };

    const getCoords = (shipping_address, parcel) => {
        Geocode.setApiKey(GOOGLE_API);
        //get geolocation to estimate shipping costs
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(position => {
                const lat = position.coords.latitude;
                const lng = position.coords.longitude;
                Geocode.fromLatLng(lat,lng).then(async response => {
                    //estimateShipping(response, parcel, shipping_address, setShippingCost);
                    setShippingCost('TODO: FIX ESTIMATION');
                },
                    error => {
                        console.log(error)
                    }
                );

            });
        }
        else {
            setShippingCost('Location data not avaliable');

        }
    };

    useEffect(() => {
        //get product
        getProduct(productId).then(async data => {
            await setItem(data)
            
            if (data.who_pays === 'buyer-pays') {
                    console.log('pak');
                    console.log(data.package);
            }
            else {
                setShippingCost('FREE shipping');
            }


            var all_photos = await data.secondary_photos.slice();
            await all_photos.unshift(data.primary_photo);
            await console.log(data); 
            await setAllPhotos(all_photos);
            //Reciever info (merchant)
            getUserInfo(data.userId).then(user => {
                getCoords(data.shipping_address, data.package);
                let sum = 0;
                if (user.ratings.length !== 0) {
                    user.ratings.forEach(rating => {
                        sum = sum + rating.rating
                    });
                    const rating = sum / user.ratings.length;
                    setUserRating({rating: rating, length: user.ratings.length});
                }
                setUserInfo(user);
            });
        });
        if (isAuthenticated()) {
            const { user: {_id, email }, token } = isAuthenticated();
            getActiveTrades(_id, token).then(data => {
                setActiveTrades(data); //might not need this
                data.map(trade => {
                    if (productId === trade.recieverItem || productId === trade.senderItem) {
                        setIsTrading(true);
                    }
                });
            });

            //check if user is onboarded already
            //consider doing this on handleBuyClick to reduce overhead
            getUserInfo(_id).then(data => {
                if (data.paypal_onboarded) {
                    //checkout link here
                }
                else {
                    //generate singin to paypal link
                    const redirectUrl = `${APP_URL}/paypal-onboarding`
                    generateSignin(email, redirectUrl, _id).then(url => {
                        console.log(url.links[1].href)
                        setBuyNowUrl(url.links[1].href);
                    });
                }
            });
        }

    },[]);

    const BuyButton = ({disabled}) => (
        <div className="mt-4 flex sm:flex-col1">
            {!disabled && 
            <button
                type="submit"
                onClick={handleBuyOpen}
                className="max-w-xs flex-1 bg-white border border-transparent rounded-md py-3 px-8 flex items-center justify-center text-base font-medium text-black hover:text-white hover:bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-indigo-500 sm:w-full border-black"
            >
                Buy Now
            </button>
            }
        </div>
    );

    const TradeButton = ({disabled}) => (
        <div className="mt-4 flex sm:flex-col1">
            {!disabled && 
            <button
                onClick={handleTradeOpen}
                type="submit"
                className="max-w-xs flex-1 bg-indigo-600 border border-transparent rounded-md py-3 px-8 flex items-center justify-center text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-indigo-500 sm:w-full"
            >
                Send Trade Offer
            </button>
            }
        </div>
    );

    const ButtonOptions = () => {
        if (isAuthenticated() && isAuthenticated().user._id === item.userId) {
            const { user: {_id } } = isAuthenticated();
            return (
                <>
                <a href={`/edit/${productId}/${_id}`}>
                    <button
                        type="button"
                        className={`bg-white max-w-xs flex-1 border rounded-md py-3 px-8 flex items-center justify-center text-base font-medium text-black hover:border-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-indigo-500 sm:w-full`}
                    >
                        Edit Listing
                    </button>
                </a>

                <button
                    type="button"
                    className={`mt-3 bg-black max-w-xs flex-1 border rounded-md py-3 px-8 flex items-center justify-center text-base font-medium text-white hover:border-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-indigo-500 sm:w-full`}
                >
                    Delete (wip)
                </button>
                </>

            );

        }
        else if (isTrading) {
            return (
                <button
                    type="button"
                    disabled
                    className={`cursor-not-allowed bg-white max-w-xs flex-1 border rounded-md py-3 px-8 flex items-center justify-center text-base font-medium text-black hover:border-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-indigo-500 sm:w-full`}
                >
                    Already Trading
                </button>
            );
        }
        else if (item.type === 'trade-sell') {
            return (
                <div className="mt-2">
                    <TradeButton disabled={false}/>
                    <BuyButton disabled={false} item={item}/>
                </div>
            );
        }
        else if (item.type === 'trade-only') {
            return (
                <div className='mt-2'>
                    <TradeButton diabled={false} />
                    <BuyButton disabled={true} item={item}/>


                </div> 
            );

        }
        else if (item.type === 'sell-only') {
            return (
                <div className=''>
                    <TradeButton disabled={true}/>
                    <BuyButton disabled={false} item={item}/>
                </div> 
            );

        }
        else {
            return (
                <></>
            );
        }
    };

    const UserSection = () => (
        <div className='border-t border-b mt-6'>
            <div className='p-4 mb-1'>
                <img
                    className="h-12 w-12 rounded-full float-left mr-2"
                    src={userInfo.profile_picture}
                    alt=""
                />
                <p className='text-md col-span-1 '><strong>{userInfo.name}</strong></p>

                {userRating.length != 0 ?
                    <div className="flex items-center">
                        {[0, 1, 2, 3, 4].map((rating) => (
                            <StarIcon
                                key={rating}
                                className={classNames(
                                    userRating.rating > rating ? 'text-indigo-500' : 'text-gray-300',
                                    'h-4 w-4 flex-shrink-0'
                                )}
                                aria-hidden="true"
                            />
                        ))}
                        <p className='text-xs text-gray-400 ml-1'>({userRating.length})</p>
                    </div>
                    :
                    <div className='flex items-center'>
                        <p className='text-xs text-gray-400'>New Seller. Rating not avaliable</p>
                    </div>
                }
            </div>
        </div>   
    );


    const ProductOverview = () => (
        <div className="bg-white">
            <div className="max-w-2xl mx-auto py-8 px-4 sm:py-12 sm:px-6 lg:max-w-7xl lg:px-8">
                <div className="lg:grid lg:grid-cols-2 lg:gap-x-8 lg:items-start">
                    {/* Image gallery */}
                    <Tab.Group as="div" className="flex flex-col-reverse">
                        {/* Image selector */}
                        <div className="hidden mt-6 w-11/12 max-w-2xl mx-auto sm:block lg:max-w-none">
                            <Tab.List className="grid grid-cols-4 gap-y-6 gap-x-0">
                                {allPhotos.map((image, i) => (
                                    <Tab
                                        key={i}
                                        className="relative h-24 w-20 bg-white rounded-md flex items-center justify-center text-sm font-medium uppercase text-gray-900 cursor-pointer hover:bg-gray-50 focus:outline-none focus:ring focus:ring-offset-4 focus:ring-opacity-50"
                                    >
                                        {({ selected }) => (
                                            <>
                                                <span className="absolute inset-0  overflow-hidden">
                                                    <img src={`${API}/static/product_photos/${image}`} alt="" className="w-full h-full object-center object-cover" />
                                                </span>
                                                <span
                                                    className={classNames(
                                                        selected ? 'ring-indigo-500' : 'ring-transparent',
                                                        'absolute inset-0  ring-2 ring-offset-2 pointer-events-none'
                                                    )}
                                                    aria-hidden="true"
                                                />
                                            </>
                                        )}
                                    </Tab>
                                ))}
                            </Tab.List>
                        </div>

                        <Tab.Panels className="w-full aspect-w-1 aspect-h-1">
                            {allPhotos.map((image, i) => (
                                <Tab.Panel key={image.id}>
                                    <img
                                        src={`${API}/static/product_photos/${image}`}
                                        className="w-full h-full object-center object-contain sm:rounded-lg"
                                    />
                                </Tab.Panel>
                            ))}
                        </Tab.Panels>
                    </Tab.Group>

                    {/* Product info */}
                    <div className="mt-10 px-4 sm:px-0 sm:mt-16 lg:mt-0 w-full">
                        <h1 className="text-3xl font-extrabold tracking-tight text-gray-900">{item.brand} </h1>
                        <Badges type={item.type}/>
                        <div className="mt-3 space-y-2">
                            <h2 className="sr-only">Product information</h2>
                            <p className='text-sm text-gray-700'>{item.name}</p>
                            <p className='text-sm text-gray-700'>Size: {item.size}</p>
                            <p className='text-sm text-gray-700'>Condition: {item.condition}</p>
                            <p className='text-sm text-gray-700'>
                                Estimated Shipping: {shippingCost}
                            </p>
                            <p className="text-md pt-2 text-black">${item.price}</p>

                        </div>

                        <ButtonOptions/>

                        <div className='mt-5 grid-cols-2'>
                            <ShieldCheckIcon className='h-10 w-10 col-span-1 float-left pr-3'/>
                            <p className='text-sm col-span-1'> Buyer Protection Guarantee </p>
                            <p className='text-xs text-gray-500 col-span-1'>Purchases are covered by PayPal Purchase Protection</p>
                        </div>


                        <UserSection />

                        <section aria-labelledby="details-heading" className="mt-6">
                            <h2 id="details-heading" className="sr-only">
                                Description
                            </h2>
                            <h2 className='font-semibold'> Description </h2>
                            <p className='text-gray-700'>{item.description}</p>
                        </section>
                    </div>
                </div>
            </div>
        </div> 
    );


    return (
        <>
            {!isAuthenticated() ?
                <>
                <SignupModal 
                    open={signupOpen} 
                    handleClose={handleSignupClose} 
                    handleOpenSignup={handleOpenSignup}
                    guest={true}
                    className='absolute'
                    />
                <SigninModal
                    open={buyOpen}
                    handleClose={handleBuyClose}
                    handleOpenSignup={handleOpenSignup}
                    guest={true}
                />
                </>
                :

                <ChooseItemModal open={openItemModal} handleClose={handleClose} items={userItems} listing={item}/>
            }
            <Layout title='' description=''>
                <ProductOverview/>
            </Layout>
        </>
    );
};

export default ProductPage;
